<div
  style="
    display: block;
    margin-left: auto;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: auto;
  "
>
  <iframe
    width="1400"
    height="900"
    [src]="iFrameSrcUrl"
    frameborder="0"
    style="border: 0"
    allowfullscreen
  ></iframe>
</div>
